// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oXm_","colMin":"styles_colMin__K9hTq"};